import styled from 'styled-components'

export const TabNav = styled.ul`
  width: 100%;
  padding: 2rem 0;
  background: ${props => props.theme.colors.inputBG};
  text-align: center;
  margin-bottom: 4.8rem;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    margin-bottom: 6.4rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-bottom: 8rem;
  }
`

export const TabLink = styled.li`
  display: inline-block;

  a {
    text-decoration: none;
    font-size: 1.6rem;
    font-family: ${props => props.active ? props.theme.fonts.primary : props.theme.fonts.bold};
    color: ${props => props.theme.colors.darkGrey};
    margin: 0 1.5rem;
    line-height: 1;
    word-break: keep-all;

    &:hover {
      &::before,
      &::after {
        height: 2px;
      }
    }

    &.active {
      font-family: ${props => props.theme.fonts.bold};
      font-weight: bold;
      border-bottom: 2px solid ${props => props.theme.colors.cobalt};

      &:hover {
        &::before,
        &::after {
          content: none;
        }
      }
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      margin: 0 3rem;
    }
  }
`
